import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** photo camera. Decorative line icon; always pair with a visible text label. */
export function CameraIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4 8h2.6l2.2-2.8h6.4L17.4 8H20A1.5 1.5 0 0 1 21.5 9.5V19A1.5 1.5 0 0 1 20 20.5H4A1.5 1.5 0 0 1 2.5 19V9.5A1.5 1.5 0 0 1 4 8z" />
      <circle cx="12" cy="13.5" r="3.4" />
    </IconSvg>
  )
}
